import React from "react";
import { Modal } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch } from "react-redux";

import { Button, CloseButton, HookFormInputGroup } from "components";
import { uiActions } from "store";
import { required, maxLength50 } from "validators/validation";

import styles from "./copyTemplate.module.scss";

const CopyTemplateModal = ({
	show,
	onHide,
	onSubmit,
	companyId,
	useCheckFeeTemplateNameMutation,
}) => {
	const dispatch = useDispatch();

	const formMethods = useForm();

	const {
		handleSubmit,
		register,
		setError,
		getValues,
		formState: { errors },
	} = formMethods;

	const { mutateAsync: checkFeeTemplateName } =
		useCheckFeeTemplateNameMutation();

	const _handleSubmit = async form => {
		let closePopup = true;
		try {
			dispatch(uiActions.showSpinnerOverlay());

			const isUsed = await checkFeeTemplateName({
				companyId,
				templateName: getValues("name"),
			});

			if (isUsed) {
				setError("name", {
					type: "emailValid",
					message: "Template name is taken",
				});

				closePopup = false;
			} else {
				await onSubmit(form);
			}
		} finally {
			dispatch(uiActions.hideSpinnerOverlay());

			if (closePopup) {
				onHide();
			}
		}
	};

	return (
		<Modal
			className={styles.modal}
			show={show}
			onHide={onHide}
			animation={false}
			centered
		>
			<Modal.Header>
				<Modal.Title className="text-center">Copy Template</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body className={styles.body}>
				<FormProvider {...formMethods}>
					<form
						onSubmit={handleSubmit(_handleSubmit)}
						className="d-flex align-items-center flex-column"
					>
						<HookFormInputGroup
							name="name"
							register={register}
							validator={{ required, maxLength50 }}
							errors={errors}
							label="New Template`s Name"
							placeholder="Enter Name"
							colInput={12}
							colLabel={12}
							className="mx-0"
						/>
						<Button
							type="submit"
							value="Create copy"
							variant="primary"
							className={styles.copyButton}
						/>
					</form>
				</FormProvider>
			</Modal.Body>
		</Modal>
	);
};

export default CopyTemplateModal;
